import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import axios from 'axios'
import i18n from './lang'
import VueI18n from 'vue-i18n'
import drag from './utils/drag'
import ElementLocale from 'element-ui/lib/locale'

import publicVariable from './utils/global.js'
Vue.prototype.GLOBAL = publicVariable
import overseaPublicVariable from './utils/overseas'
Vue.prototype.OVERSEA = overseaPublicVariable

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log


import * as filters from './filters' // global filters

// my compontent

import titleBorder from './components/EpcTitle/titleBorder.vue'
import subnav from './components/EpcTitle/subnav.vue'

Vue.component('titleBorder', titleBorder)
Vue.component('subnav', subnav)


Vue.prototype.$axios = axios
// axios优化2: 配置基础地址, 只要配置了基础地址, 将来axios的请求都会自动拼上这个基准路径
// axios.defaults.baseURL = 'https://tis-cos-dev-new-1256914302.cos.ap-shanghai.myqcloud.com'

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})
Vue.use(VueI18n)
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 页面表格高度设置公用
// window.localStorage.setItem('tableHeight', 'calc(100vh - 380px)')

Vue.config.productionTip = false
Vue.config.lang = 'zh-cn'
// Vue.config.lang = navigator.language   获取浏览器语言

// Vue.use(Element, {
//   size: Cookies.get('size') || 'medium', // set element-ui default size
//   i18n: (key, value) => i18n.t(key, value)
// })
ElementLocale.i18n((key, value) => i18n.t(key, value))
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  drag,
  render: h => h(App)
})
